import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const HMXHyacinthV2 = () => (
  <ArticleWrapper articleId="hmx_hyacinth_v2">
    <div className="prose prose-invert mx-auto p-6">
      <h1>HMX Hyacinth V2</h1>
      {/* Add your HMX Hyacinth V2 article content here */}
      <p>This is a placeholder article for the HMX Hyacinth V2 switch. More content coming soon.</p>
    </div>
  </ArticleWrapper>
);

export default HMXHyacinthV2;
